import type { ReactNode } from 'react'
import styles from './StatusPage.module.css'

interface StatusPageProps {
  children: ReactNode
}

export function StatusPage({ children }: StatusPageProps) {
  return (
    <div className={styles.root}>
      <div className={styles.particles}>
        <div className={styles.particle} />
        <div className={styles.particle} />
        <div className={styles.particle} />
        <div className={styles.particle} />
        <div className={styles.particle} />
        <div className={styles.particle} />
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  )
}
